var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDianziquzheng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2f32"
    },
    d: "M139.58,0H884.42a46,46,0,0,1,32.93,13.41q14,13.41,14,32.38V232.27q0,20.11-14,33.51a46,46,0,0,1-32.93,13.39H139.58a46,46,0,0,1-32.94-13.39q-14-13.41-14-33.51V45.79q0-19,14-32.38A46,46,0,0,1,139.58,0Zm0,371.85H884.42q19,0,32.93,14t14,32.93v186.5q0,19-14,32.94t-32.93,14H139.58q-19,0-32.94-14t-14-32.94V418.75q0-19,14-32.93T139.58,371.85Zm0,373H884.42a46,46,0,0,1,32.93,13.41q14,13.41,14,33.49V978.21q0,19-14,32.39A46,46,0,0,1,884.42,1024H139.58a46,46,0,0,1-32.94-13.39q-14-13.41-14-32.39V791.73q0-20.09,14-33.49A46,46,0,0,1,139.58,744.83Zm46.9-652.15v93.8h92.68V92.68Zm0,373v92.67h92.68V465.66Zm0,371.85v93.8h92.68v-93.8Zm185.37-651h46.9V92.68h-46.9Zm0,371.85h46.9V465.66h-46.9Zm0,373h46.9v-93.8h-46.9Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianziquzheng);
export default __webpack_public_path__ + "static/media/dianziquzheng.805d2d49a9187cd966eb71a11a55a9ce.svg";
export { ForwardRef as ReactComponent };